
// import { Avatar, Box, Button, Grid, Tab, Tabs, Typography } from '@mui/material'
// import React, { useEffect, useState } from 'react'
// import profile_image from "../../../Assets/Media.jpg"
// import actions from '../../../ReduxStore/actions';
// import { batch, useDispatch, useSelector } from 'react-redux';
// import { toast, ToastContainer } from 'react-toastify';

// const SuggestionConnections = () => {

//     const [tabIndex, setTabIndex] = useState(0);
//     const [inviteData, setInviteData] = useState([]);
//     console.log(inviteData, "lengthofdataa")

//     const dispatch = useDispatch()
//     const sessionUserId = sessionStorage.getItem("userId")
//     const { updateConnectionRequestStatus } = useSelector(
//         (state) => state?.updateConnectionRequestStatus
//     );

//     //get all post api integration



//     useEffect(() => {


//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: tabIndex === 0 ? `connectionRequestsFromUser/${sessionUserId}` : `yourConnectionRequests/${sessionUserId}`,
//             };
//             const response = await dispatch(tabIndex === 0 ? actions.CONNECTIONREQUESTSFROMUSER(data1) : actions.YOURCONNECTIONREQUESTS(data1));

//             console.log(response, "responseresponse")

//             if (response?.payload?.message === "Pending requests fetched.") {
//                 console.log("hiiiiiiiiiiiiiiii")

//                 const responseData = response?.payload?.data?.map((data) => ({
//                     connection_id: data?.connection_id,
//                     name: tabIndex === 0 ? `${data?.Sender?.first_name} ${data?.Sender?.last_name}` : `${data?.Receiver?.first_name} ${data?.Receiver?.last_name}`,
//                     course: tabIndex === 0 ? data?.Sender?.course : data?.Receiver?.course,
//                     campus: tabIndex === 0 ? data?.Sender?.campus : data?.Receiver?.campus,
//                     profileImage: tabIndex === 0 ? data?.Sender?.profileImage : data?.Receiver?.profileImage,
//                     batch: tabIndex === 0 ? data?.Sender?.batch : data?.Receiver?.batch



//                 }))
//                 setInviteData(responseData)

//             }
//         }
//         fetchData()


//     }, [tabIndex, updateConnectionRequestStatus])

//     // useEffect(() => {
//     //     setInviteData(tabIndex === 0 ? invites : myRequests);
//     // }, [tabIndex]);

//     const handleAcceptRejectbutton = async (connection_id, status) => {
//         const data1 = {
//             data: {
//                 status: status
//             },
//             method: "put",
//             apiName: `updateConnectionRequestStatus/${connection_id}`,
//         };
//         const response = await dispatch(actions.UPDATECONNECTIONREQUESTSTATUS(data1));
//         if (response?.payload?.message === (status === "accepted" ? "Connection accepted." : "Connection rejected.")) {
//             console.log("itsssssssssss")
//             toast.success(`Connection ${status === "accepted" ? "accepted" : "rejected"} successfully!`)
//         } else {
//             toast.error(response?.payload?.message)
//         }



//         // const updated = inviteData.filter((_, index) => index !== indexToRemove);
//         // setInviteData(updated);
//     };

//     return (
//         <Box>
//             <Tabs
//                 value={tabIndex}
//                 onChange={(_, newValue) => setTabIndex(newValue)}
//                 sx={{ mb: 2 }}
//             >
//                 {/* <Tab label="Invitations" textTransform="none"/>
//                 <Tab label="My Requests" /> */}
//                 <Tab label={

//                     <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black" }}>
//                         Invitations
//                         {/* ({inviteData?.length}) */}
//                     </Typography>
//                 }
//                     // "Invitations" 
//                     sx={{ textTransform: 'none' }} />
//                 <Tab label={
//                     <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black" }}>
//                         My Requests
//                         {/* ({inviteData?.length}) */}
//                     </Typography>
//                 }
//                     sx={{ textTransform: 'none' }} />
//             </Tabs>

//             {/* <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black" }}>
//                 {tabIndex === 0 ? 'Invitations' : 'My Requests'} ({inviteData.length})
//             </Typography> */}


//             {/* {inviteData?.length > 0 ? ( */}
//             {Array.isArray(inviteData) && inviteData.length > 0 ? (
//                 <>
//                     {inviteData?.map((invite, index) => (
//                         <Grid container key={index}
//                             sx={{
//                                 background: "white",
//                                 p: 2,
//                                 border: "1px solid white",
//                                 mt: 2
//                             }}
//                         >
//                             <Grid size={{ xs: 12, md: 8, sm: 12 }}>
//                                 <Box display="flex" alignItems="center" gap={1} mb={1}>
//                                     <Avatar
//                                         src={invite?.profileImage}
//                                         sx={{
//                                             border: "1px solid gray",
//                                             height: 80,
//                                             width: 80,
//                                             "& .MuiAvatar-img": {
//                                                 objectFit: "contain"
//                                             }
//                                         }}
//                                     />
//                                     <Box>
//                                         <Typography variant='subtitle1' sx={{ color: 'black' }}>{invite?.name}</Typography>
//                                         <Typography variant="subtitle2" sx={{ color: 'gray', mt: 0.2 }}>{invite?.course} | {invite?.campus}</Typography>
//                                         <Typography variant="body1">{invite?.batch}</Typography>
//                                     </Box>
//                                 </Box>
//                             </Grid>
//                             <Grid
//                                 // item xs={12} md={4} sm={12}
//                                 size={{ xs: 12, md: 4, sm: 12 }}
//                                 sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
//                             >
//                                 <Box>
//                                     {tabIndex === 0 ? (
//                                         <>
//                                             <Button
//                                                 onClick={() => handleAcceptRejectbutton(invite?.connection_id, "rejected")}
//                                                 sx={{
//                                                     background: "#f4f2ee",
//                                                     color: "gray",
//                                                     textTransform: "none",
//                                                     mr: 2
//                                                 }}
//                                             >
//                                                 Ignore
//                                             </Button>
//                                             <Button
//                                                 onClick={() => {
//                                                     handleAcceptRejectbutton(invite?.connection_id, "accepted")
//                                                 }}
//                                                 sx={{
//                                                     background: "var(--main-color)",
//                                                     color: "white",
//                                                     textTransform: "none"
//                                                 }}
//                                             >
//                                                 Accept
//                                             </Button>
//                                         </>
//                                     ) : (
//                                         <Button
//                                             // onClick={() => handleIgnorebutton(index)}
//                                             sx={{
//                                                 background: "#f4f2ee",
//                                                 color: "gray",
//                                                 textTransform: "none",
//                                                 mr: 2
//                                             }}
//                                         >
//                                             Requested
//                                         </Button>

//                                     )}

//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     ))}
//                 </>)
//                 : (
//                     <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "50vh" }}>
//                         <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "gray" }}>
//                             {tabIndex === 0 ? "No Invitations found" : "No requests found"}

//                             {/* ({inviteData?.length}) */}
//                         </Typography>
//                     </Box>

//                 )

//             }
//             < ToastContainer
//                 position="top-right"
//                 autoClose={1500}
//                 hideProgressBar={false}
//                 newestOnTop={false}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//                 theme="dark"
//             />
//         </Box>
//     );
// };

// export default SuggestionConnections;




import { Avatar, Box, Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import profile_image from "../../../Assets/Media.jpg"
import { useDispatch, useSelector } from 'react-redux'
import actions from '../../../ReduxStore/actions'
import { toast, ToastContainer } from 'react-toastify'

const SuggestionConnections = () => {
    const [inviteData, setInviteData] = useState([])


    const dispatch = useDispatch()
    const sessionUserId = sessionStorage.getItem("userId")
    const { sendConnectionRequest } = useSelector(
        (state) => state?.sendConnectionRequest
    );

    //get all post api integration
    const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';



    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `suggestConnections/${sessionUserId}`,
            };
            const response = await dispatch(actions.SUGGESTCONNECTIONS(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Suggestions fetched.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    user_id: data?.user_id,
                    name: `${capitalize(data?.first_name)} ${capitalize(data?.last_name)}`,
                    course: capitalize(data?.course),
                    campus: capitalize(data?.campus),
                    profileImage: data?.profileImage,
                    batch: data?.batch



                }))
                setInviteData(responseData)

            }
        }
        fetchData()


    }, [sendConnectionRequest])


    const handleConnectButton = async (user_id) => {
        console.log(user_id, "userrrrrrrrr")
        const data1 = {
            data: {
                sender_id: Number(sessionUserId),
                receiver_id: Number(user_id)
            },
            method: "post",
            apiName: `sendConnectionRequest`,
        };
        const response = await dispatch(actions.SENDCONNECTIONREQUEST(data1));
        console.log(response, "responsedataaaaaaa")
        if (response?.payload?.message === "Connection request sent.") {
            toast?.success('Connection request sent successfully!')
        } else {
            toast.error(response?.payload?.message)
        }


    }

    return (
        <Box sx = {{ minHeight: "80vh" }}>
            <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "black" }}>
                Suggestions({inviteData?.length})
            </Typography>
            <Grid container spacing={2}>

                {inviteData?.length > 0 ? (
                    <>
                        {inviteData?.map((invite, index) => (
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container
                                    sx={{
                                        // boxShadow: 4,
                                        background: "white",
                                        p: 2,
                                        border: "1px solid white",
                                        mt: 2
                                    }}>
                                    <Grid size={{ xs: 12, md: 12, sm: 12 }}>

                                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                                            <Avatar src={invite.profile_image}
                                                sx={{
                                                    border: "1px solid gray",
                                                    height: 80,
                                                    width: 80,
                                                    "& .MuiAvatar-img": {
                                                        objectFit: "contain"
                                                    }
                                                }} />
                                            <Box>
                                                <Typography variant='customText' sx={{ color: 'black' }}>{invite?.name}</Typography>
                                                <Typography variant="subtitle2" sx={{ color: 'gray', mt: 0.2 }}>{invite?.course}</Typography>
                                                <Typography variant="subtitle2" sx={{ color: 'gray', mt: 0.2 }}>{invite?.campus}</Typography>

                                                <Typography variant="body1">{invite?.batch}</Typography>

                                            </Box>
                                        </Box>

                                    </Grid>
                                    <Grid size={{ xs: 12, md: 12, sm: 12 }}
                                        sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}
                                    >
                                        <Box>

                                            <Button

                                                onClick={() => {
                                                    handleConnectButton(invite?.user_id)
                                                }
                                                }
                                                sx={{
                                                    background: "var(--main-color)",
                                                    color: "white",
                                                    textTransform: "none"
                                                }}
                                            >
                                                Connect
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}
                    </>
                )
                    : (
                        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "50vh", width: "100%" }}>
                            <Typography variant='subtitle2' sx={{ fontSize: '17px', color: "gray" }}>
                                No Suggestions found

                                {/* ({inviteData?.length}) */}
                            </Typography>
                        </Box>

                    )}

            </Grid>
{/* </Grid> */ }
<ToastContainer
    position="top-right"
    autoClose={1500}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="dark"
/>
        </Box >
    )
}

export default SuggestionConnections
